import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {
  style?: React.CSSProperties;
}

export const WarningSvg: React.FC<Props> = ({ style }) => {
  const colors = useStateSelector((state) => state.theme.colors);
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
      <path
        d="M2.13734 16.7148H17.2923C17.5385 16.7148 17.7804 16.6544 17.9945 16.5394C18.2085 16.4245 18.3874 16.259 18.5136 16.0592C18.6398 15.8593 18.709 15.6319 18.7145 15.3992C18.72 15.1664 18.6615 14.9363 18.5448 14.7313L10.9678 1.42254C10.4302 0.478944 8.99947 0.478944 8.46193 1.42254L0.884875 14.7313C0.768189 14.9363 0.709724 15.1664 0.715195 15.3992C0.720667 15.6319 0.789887 15.8593 0.916091 16.0592C1.0423 16.259 1.22117 16.4245 1.43522 16.5394C1.64928 16.6544 1.8912 16.7148 2.13734 16.7148Z"
        stroke={colors.statusRed}
        strokeWidth="1.4297"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.91396 7.2139L9.75754 10.5384L9.6014 7.21526C9.60044 7.19402 9.60382 7.1728 9.61133 7.15291C9.61884 7.13301 9.63034 7.11486 9.6451 7.09956C9.65987 7.08425 9.6776 7.07212 9.69722 7.06391C9.71683 7.05569 9.73791 7.05156 9.75918 7.05177C9.78007 7.05197 9.80071 7.05636 9.81988 7.06467C9.83905 7.07298 9.85636 7.08505 9.87079 7.10017C9.88521 7.11528 9.89647 7.13313 9.90388 7.15266C9.9113 7.1722 9.91472 7.19302 9.91396 7.2139Z"
        stroke={colors.statusRed}
        strokeWidth="0.871989"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75969 13.129C9.86748 13.129 9.97285 13.0971 10.0625 13.0372C10.1521 12.9773 10.222 12.8922 10.2632 12.7926C10.3045 12.693 10.3152 12.5835 10.2942 12.4777C10.2732 12.372 10.2213 12.2749 10.1451 12.1987C10.0688 12.1225 9.97174 12.0706 9.86602 12.0495C9.7603 12.0285 9.65072 12.0393 9.55113 12.0805C9.45155 12.1218 9.36643 12.1916 9.30655 12.2813C9.24666 12.3709 9.2147 12.4763 9.2147 12.5841C9.2147 12.7286 9.27212 12.8672 9.37433 12.9694C9.47653 13.0716 9.61515 13.129 9.75969 13.129Z"
        fill={colors.statusRed}
      />
    </svg>
  );
};
